// extracted by mini-css-extract-plugin
export default {"work-flow":"WorkFlow_work-flow__zGino","dropdown":"WorkFlow_dropdown__+IELf","loader-container":"WorkFlow_loader-container__WVjlU"};